module.exports = __webpack_public_path__ + "img/a27.20081931.svg";